export default __webpack_public_path__ + "74049d4d83e281bfd0ddffad16c0d013.svg";